import * as React from 'react'
import styled from 'styled-components'
import {Link} from 'react-router-dom'

interface Props {
  next?: string
  text: string
  addOn?(): void
  disabled?: boolean
  preventLink?: boolean
  hideOnMobile?: boolean
}

export default class FormContactButton extends React.Component<Props, any> {
  isSafari = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    return (
      userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1
    )
  }

  onClickLink = (e) => {
    const { preventLink } = this.props
    if (preventLink) e.preventDefault()
  }

  render() {
    const { addOn, disabled, next, text } = this.props
    return (
          <Link id='next' to={next + location.search || ''} onClick={(e) => this.onClickLink(e)}>
            <StartBtn
              style={{ height: 'unset', minWidth: '12em' }}
              onClick={addOn}
              disabled={disabled}>
              {text}
            </StartBtn>
          </Link>
    )
  }
}



const StartBtn = styled.button`
  color: white;
  background: #974353;
  background: ${(props) => (props.disabled ? '#C6A3A9' : '#974353')};
  border: none;
  padding: 18px 20px;
  cursor: pointer;
  font-family: Montserrat;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: 18px;
  font-weight: bold;
  margin: 20px 5px 10px;
  height: 100%;
  width: 100%;
`


// WEBPACK FOOTER //
// ./src/components/atoms/wizard/FormContactButton.tsx